import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { ProgressBar } from './'
import { AccountStyle } from './../styles'
import Router from './../services/Router'
import { ArrowDrop, RM } from './'
import { Arrow } from './Shapes';

const STOCK_ROLE = [
  'ROLE_SELLER',
  'ROLE_STORE_MANAGER',
  'ROLE_ZONE_MANAGER',
  'ROLE_MANAGER',
  'ROLE_ADMIN',
  'ROLE_SUPER_ADMIN',
]

const CHALLENGE_ROLE = [
  'ROLE_SELLER',
  'ROLE_STORE_MANAGER',
]

class Account extends Component {
  state = {
    type: 'super seller',
  }
  controlPanel = () => {
    this.props.callbackClick()
  }

  render() {
    const { open, name, picture, role, quizz, total } = this.props
    const real_score = parseInt(quizz) / parseInt(total) * 100
    return (
      <div className={`account-card ${ AccountStyle(open, picture && picture !== '/media/cache/default/images/default_cover.png' ? picture : '') }`}>
        <div className="flex items-center account-card--inner" onClick={this.controlPanel}>
          <div className="account-card--picture">
            { picture && picture !== '/media/cache/default/images/default_cover.png' ? '' : <RM width={24} height={24} />}
          </div>
          <div className="account-card--info">
            <div className="account-card--name">{ name } <ArrowDrop width={12} height={12}/></div>
            {CHALLENGE_ROLE.indexOf(role) !== -1 && <ProgressBar theme="red" x={real_score} /> }
            </div>
        </div>
        <div className="account-panel">
          <ul className="reset">
            <li> <NavLink to={Router.information.path}> My information </NavLink></li>
            {/* { STOCK_ROLE.indexOf(role) !== -1 && <li> <NavLink to={Router.stock.path}> My stock </NavLink></li> } */}
            { CHALLENGE_ROLE.indexOf(role) !== -1 && <li> <NavLink to={Router.challenge.path}> My challenge </NavLink></li> }
            <li> <NavLink to={Router.team.exactPath}> Team </NavLink></li>
            <li> <NavLink to={Router.event.path}> Agenda </NavLink></li>
            <li> <NavLink to={Router.counterfeits.path}> Counterfeits </NavLink></li>
            <li> <NavLink to={Router.thefts.path}> Thefts </NavLink></li>
          </ul>
        </div>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    name: Session.username,
    role: Session.role,
    picture: Session.picture,
    quizz: Session.challenge.quizz,
    total: Session.challenge.quizzTotal
  }),
)(Account)



// WEBPACK FOOTER //
// ./src/components/Account.js